export default __webpack_public_path__ + "static/media/approval.32105946.png";